import type React from 'react';

/**
 * The HUD root's capture-phase click handler: after a mouse or touch click on a HUD button, hand
 * focus back to the game. InputSystem drops every game key while a button has focus (so Space and
 * Enter press the button rather than jump or chat), and a clicked button keeps focus, so one click
 * on a hotbar slot, a chat tab or the quest tracker's pin used to leave the hero unable to move
 * until the player clicked the world (E3, 2026-11-03). A keyboard press (`detail` 0) keeps its
 * focus, and so does focus the click moved somewhere else, such as into a menu it opened.
 */
export function releaseHudPointerFocus(event: React.MouseEvent<HTMLElement>): void {
  if (event.detail === 0 || !(event.target instanceof Element)) return;
  const control = event.target.closest('button, [role="button"], [role="tab"]');
  if (!(control instanceof HTMLElement)) return;
  // Bound in the capture phase (some HUD controls, like the chat tabs, stop the click's bubbling)
  // and run once the click's own handlers are done.
  setTimeout(() => { if (control === document.activeElement) control.blur(); }, 0);
}
